<template>
  <div>
    <!--<spinner v-if="!isHaveData"></spinner>-->
    <div
        class="flex flex-col w-full py-3 md:px-8 px-4 my-6 border border-grey-dark rounded-lg bg-white text-main-text text-sm font-normal">
      <div class="w-full h-full cursor-pointer flex justify-start py-2 items-start select-none relative"
           @click.prevent="show_registration = !show_registration; $emit('expandToggle', event.uuid); " ref="registr">
        <div class="grid w-full">
          <div>
            <div class="flex items-center">
              <p class="text-brand-darker font-semibold flex-1 max-w-4/5">
                {{ event.game_name }}
              </p>

              <!--              badge  dist format      -->
              <span v-if="event.distribution_format"
                    class="text-white font-bold text-10px py-1 px-3 rounded ml-4 max-h-6 md:max-h-8 mt-5 md:mt-0"
                    :class="[event.distribution_format === 'online'?'bg-brand-light':'bg-brand-darker']"
                    v-text="event.distribution_format"></span>
              <!-- registration link -->
              <div class="flex text-10px md:text-sm mt-2 md:mt-0 ml-3 relative">
                <div class="mr-2" @click.prevent.stop="copyTextArea" @mouseleave="showRegistrationLink = false"
                     @mouseover="showRegistrationLink = true">
                  <img class="w-2 md:w-4" src="@/assets/SVG/copy-link-brand.svg"/>
                </div>
                <div
                    class="text-10px md:text-sm absolute w-50 bg-white mt-4 ml-2 py-2 text-center rounded-sm shadow-mozgo-2 "
                    v-if="showRegistrationLink" @click.prevent.stop="copyTextArea">
                  Ссылка на регистрацию
                </div>
              </div>
            </div>
            <div v-if="item.dates.length === 0" class="flex">
              <p class>Дата не указана</p>
            </div>
          </div>
          <div class="flex self-center">
            <div class="flex">
              <p class="text-10px md:text-sm mt-2 md:mt-0">
                {{ getEventDate(event.played_at)[0] }}&nbsp;
                <span>/&nbsp;{{ event.place }}</span>
              </p>
            </div>

          </div>
          <div class="whitespace-no-wrap flex self-center">
            <p class="text-10px md:hidden mt-2">Зарегистрировано:&nbsp;
              <span v-if="event.taken_type === 'team'"
                    class="text-brand-darker  font-bold">{{ event.taken_team }}/{{ event.team_capacity }} команд</span>
              <span v-else class="text-brand-darker  font-bold">{{ event.taken_people }}/{{ event.people_capacity }} игроков</span>
            </p>
            <div class="flex  whitespace-no-wrap hide-element">
              <p>Зарегистрировано:&nbsp;</p>
              <p v-if="event.taken_type === 'people'" class="text-brand-light font-semibold">
                {{ event.taken_people }} ({{ event.people_capacity }}) игроков</p>
              <p v-if="event.taken_type === 'team'" class="text-brand-light font-semibold">
                {{ event.taken_team }} ({{ event.team_capacity }}) команд</p>
            </div>


          </div>
        </div>
        <div class="flex self-center">
          <div class="absolute pin-r pin-t flex">
            <!--   delete icon-->
            <img
                v-if="user.role === 'editor' && show_registration"
                class="my-auto w-4 h-4 md:w-auto md:h-auto cursor-pointer"
                @click.prevent.stop="delete_event_modal = true"
                src="@/assets/SVG/trash-bin.svg"
                alt="delete-icon"
            />
            <!--<edit-modal @editConfirmed="editAdvertisement" :uuid="item.uuid" :draft_uuid="item.draft_uuid" class="flex items-center"></edit-modal>-->
            <font-awesome-icon
                :icon="['far', 'angle-down']"
                size="2x"
                :class="rotateArrow"
                fixed-width
                class="arrow text-additional-text cursor-pointer -mr-3"
                @click.stop="show_registration = !show_registration; $emit('expandToggle', event.uuid)"
            ></font-awesome-icon>
          </div>
        </div>
      </div>

      <div v-if="show_registration" class="md:-mx-8">
        <div class="text-lg pl-8 pt-6 -mb-4 flex justify-between content-start">
          <div class="flex justify-end ml-auto flex-row mr-5 h-10">
            <button v-show="changeToMainListButton" @click="recoverLine"
                    class="py-2 text-sm outline-none bg-white rounded-full text-main-text border border-main-text hover:border-brand-light hover:bg-brand-light hover:text-white ml-4 px-4">
              В
              основной список
            </button>
            <button v-show="deleteButton" @click="deleteLine"
                    class="py-2 text-sm w-40 outline-none bg-white rounded-full text-main-text border border-main-text hover:border-brand-light hover:bg-brand-light hover:text-white ml-4">
              Удалить
            </button>
            <button v-show="changeDateButton" @click="showChangeDate = true"
                    class="py-2 text-sm w-40 outline-none bg-white rounded-full text-main-text border border-main-text hover:border-brand-light hover:bg-brand-light hover:text-white ml-4">
              На
              другой день
            </button>

          </div>
        </div>

        <registration-data :event="event" :isCorpleahue="isCorpLeague" :registration_date="registration_date"
                           ref="regData" :events="getAllEvents"
                           @addParams="addParams" :downloadImages="downloadImages" class="font-normal"
                           @update="updateList"></registration-data>

        <div class="flex justify-between md:mx-8 md:my-8">
          <!-- <div class="hidden md:flex items-center cursor-pointer" @click="adding_team_modal=true"> // Добавление команды партнёром,  не удалять
            <button
              class="hover-up outline-none rounded-full flex flex-row justify-center items-center h-8 w-8 bg-additional-text">
              <font-awesome-icon class="text-white text-xl" :icon="['fal', 'plus']">
              </font-awesome-icon>
            </button>
            <div class="text-xs text-additional-text font-bold ml-4">Добавить команду</div>
          </div> -->
          <router-link :to="{name : 'applicationsExport', query:{cityId :city , eventDayId:event.uuid}}"
                       target = "_blank"
                       v-if="user.role === 'editor'"
                       class="outline-none mt-6 md:mt-0 text-sm underline text-main-text font-medium mr-auto md:ml-auto md:mr-8 p-1 ">
            Список команд
          </router-link>
          <div class="hidden md:block">
            <div class="hidden md:flex justify-start items-center cursor-pointer" @click.prevent.stop="downloadExcel">
              <img class="mr-2" src="@/assets/SVG/download-data-base.svg" alt/>
              <p class="underline text-main-text">Выгрузить данные в Excel</p>
            </div>
            <div v-if="isCorpLeague" class="hidden md:flex justify-start items-center cursor-pointer mt-4"
                 @click.prevent.stop="downloadAllLogos">
              <img class="mr-2" src="@/assets/SVG/download-data-base.svg" alt/>
              <p class="underline text-main-text">Выгрузить все логотипы</p>
            </div>
          </div>


        </div>


        <!--<record-data v-if="!isEditing" :item="item" @updated="$emit('updated')"></record-data>-->
        <!--<edit-record v-else :uuid="item.uuid" :draft_uuid="item.draft_uuid" @closed="isEditing = false" ></edit-record>-->
      </div>
      <div class="divider mt-12 mb-3" v-if="show_registration && mobile">

      </div>
      <div class="ml-5" v-if="show_registration && mobile">
        <div class="">
          <div class="flex">
            <img src="@/assets/SVG/exclimation-mark.svg" alt/>
            <span class="mx-2 font-normal text-mxs">Команда в нескольких списках</span>
          </div>
          <div class="flex mt-2 -ml-1">
            <img src="@/assets/SVG/yellow-point.svg" alt/>
            <span class="text-mxs font-normal mr-10 mx-2">Резерв</span>
          </div>
        </div>
        <div class="flex mt-2 -ml-1">
          <img class="" src="@/assets/SVG/new_team.svg" alt/>
          <span class=" font-normal text-mxs mx-2">Команда играет первый раз</span>
        </div>
      </div>
      <change-date-modal
          v-if="showChangeDate"
          @close="showChangeDate = false"
          :uuid="event.uuid"
          :record_id="event.event_record_id"
          :active_ids="active_ids"
          @error_change="delete_modal = true;"
          @change="showChangeDate = false;$emit('updateEvent', $event); updateList()"
      ></change-date-modal>
      <!-- <confirm-delete key="delete_modal" v-if="delete_modal" @close="delete_modal = false;showChangeDate =false;"

                            @white_button="delete_modal = false; showChangeDate =false;"
                            :text="'Перед переносом заявки, пожалуйста убедитесь, что в текущей серии игр заявка не находится в основных списках'"
                            :button_text_firs="'Ок'"
                            class="upper flex absolute pin"></confirm-delete> -->
      <error-modal v-if="delete_modal" @close="delete_modal = false; showChangeDate =false;"/>

      <adding-team-modal v-if="adding_team_modal"
                         @close="adding_team_modal=false"
                         :isCorpLeague="isCorpLeague">
      </adding-team-modal>

      <!--      delete event modal -->
      <delete-modal
          key="delete_event_modal"
          v-if="delete_event_modal"
          @close="delete_event_modal = false"
          @yellow_button="delete_event_modal = false"
          @white_button="deleteEvent"
          :text="'Вы уверены, что хотите удалить мероприятие?'"
          :button_text_firs="'Да'"
          :button_text_second="'Нет'"
          class="z-50 flex"
      ></delete-modal>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import FileDownload from 'js-file-download';
import client from '@/clients/partners';
import DeleteModal from '../../events/order/delete-modal';
import format from 'date-fns/format';
import ru from 'date-fns/locale/ru';
import RegistrationData from './registration-data';
import ChangeDateModal from './changeDateModal';
import ConfirmDelete from '@/views/partners/events/order/delete-modal.vue';
import ErrorModal from './error-modal';
import AddingTeamModal from '../adding-team-modal';
import base from '@/clients/auth';

// import axios from 'axios';

export default {
  name: 'registration-list',
  components: {
    ChangeDateModal,
    RegistrationData,
    DeleteModal,
    ConfirmDelete,
    ErrorModal,
    AddingTeamModal,
  },
  props: ['event', 'city', 'getAllEvents', 'expandedRegs', 'user'],
  data() {
    return {
      show_registration: false,
      isEditing: false,
      showRegistrationLink: false,
      changeDateButton: false,
      changeToMainListButton: false,
      deleteButton: false,
      delete_event_modal: false,

      showChangeDate: false,
      // isHaveData: false,
      registration_date: {},
      active_ids: [],
      delete_modal: false,
      showCategory: false,
      item: {
        dates: [
          {
            played_at: '2019-05-07',
          },
        ],
        game_type: 'Классическая игра',
        game_topic: '',
      },

      adding_team_modal: false,
    };
  },


  watch: {
    show_registration() {
      if (this.show_registration === true) {
        this.getEventData();
      }
    },
    showChangeDate() {
      if (this.showChangeDate) {
        document.body.style.overflow = 'hidden';
        // this.$emit('overflow', {overflow: true})
      } else {
        // this.$emit('overflow', {overflow: false})
      }
    },


    '$route.query.like': {
      handler() {
        this.show_registration = !!this.$route.query.like;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions(['selectShowModal']),
    ...mapActions(['selectModalText']),
    getEventData() {
      client
        .get(`/applications?city_id=${this.city}&event_day_id=${this.event.uuid}`)
        .then(({ data }) => {
          this.registration_date = data;
          // this.isHaveData = true;
        });
    },
    recoveryButton() {
      this.changeToMainListButton = false;
      this.changeDateButton = false;
      this.deleteButton = false;
    },
    addParams(params) {
      this.recoveryButton();
      if (params.ids.length) {
        this.$emit('restoreOtherLines', { uuid: this.event.uuid });
      }
      if (params.status === 'active') {
        this.active_ids = params.ids;
        this.deleteButton = true;
        this.changeDateButton = true;
      }
      if (params.status === 'reserve') {
        this.active_ids = params.ids;
        this.deleteButton = true;
        this.changeToMainListButton = true;
        this.changeDateButton = true;
      }
    },
    deleteLine() {
      client
        .delete(`/applications/dates/${this.event.uuid}`, {
          headers: {
            'Content-Type': 'application/json',
          },
          data: {
            applications_ids: [...this.active_ids],
          },
        })
        .then(() => {
          this.$emit('updateEvent', { uuid: this.event.uuid });
          this.selectModalText('Удаление завершено');
          this.selectShowModal(true);

          this.updateList();
        });
    },
    restoreLine() {
      if (this.$refs.regData) {
        this.$refs.regData.restoreCheckedLine();
      }
    },
    recoverLine() {
      client
        .patch(`/applications/dates/${this.event.uuid}`, {
          applications_ids: [...this.active_ids],
          status: 'active',
        })
        .then(() => {
          this.selectModalText('Востановление завершено');
          this.selectShowModal(true);
          this.updateList();
        })
        .catch((error) => {
          this.delete_modal = true;
        });
    },


    updateList() {
      this.deleteButton = false;
      this.changeToMainListButton = false;
      this.changeDateButton = false;
      this.recoveryButton();
      this.registration_date = {};
      this.active_ids = [];
      this.$refs.regData.clearSelectedLine();
      this.$emit('updateEvent', { uuid: this.event.uuid });
      this.selectModalText('Изменения сохранены');
      this.selectShowModal(true);
    },
    getEventDate(date) {
      const dates = [];
      dates.push(format(date, 'DD MMMM, dd, HH:mm', { locale: ru }));
      return dates;
    },
    downloadExcel() {
      client
        .get(`applications/dates/${this.event.uuid}/excels`, {
          responseType: 'blob',
        })
        .then((response) => {
          FileDownload(
            response.data,
            `${this.event.played_at}.${this.event.place}.xlsx`,
          );
        });
    },

    downloadImages(images) {
      if (images.length < 1) return;
      const rr = images.map(item => `id[]=${item}`);
      const ref = `${base.defaults.baseURL}/api/media/download?${rr.join('&')}`;

      const link = document.createElement('a');
      link.href = ref;
      link.setAttribute('download', 'flName');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // const urlArray = file.split('/');
      // const bucket = 'mozgo-test';
      // const key = `${urlArray[3]}/${urlArray[4]}`;
      // const s3 = new AWS.S3();
      // s3.config.credentials = { accessKeyId: '', region: 'eu-north-1', secretAccessKey: '' };
      // //s3.config.region = 'eu-north-1';
      // const params = { Bucket: bucket, Key: key };
      // console.dir(s3);
      // s3.getObject(params, (err, data) => {
      //   console.dir(err);
      //   const blob = new Blob([data.Body], { type: data.ContentType });
      //   const link = document.createElement('a');
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = file;
      //   link.click();
      // });

      // FileDownload(
      //   file,
      //   `${name}-${this.getImageName(file)}`,
      // );
      // });
    },

    getImageName(image) {
      console.log(image);
      const arr = image.split('/');
      return arr[arr.length - 1];
    },

    downloadAllLogos() {
      const allLogos = this.registration_date.active.reduce((acc, item) => {
        const images = Object.keys(item.team.company.media);
        return [...acc, ...images];
      }, []);
      this.downloadImages(allLogos);
    },
    copyTextArea() {
      if ((this.event.parent_type && this.event.parent_type !== 'Мозгобойня Live') || !this.event.parent_type) {
        this.$clipboard(`${window.location.hostname}/?gameId=${this.event.uuid}&city=${this.city}`);
      } else {
        this.$clipboard(`https:${process.env.VUE_APP_MOZGO_PARTY_LIVE_API}/reg/${this.event.gameId}`);
      }
      this.selectModalText('Ссылка на регистрацию скопирована');
      this.selectShowModal(true);
    },
    deleteEvent() {
      base.delete(`/api/event-day?eventDayId=${this.event.uuid}`)
        .then(() => {
          this.$emit('updateEvent');
          this.delete_event_modal = false;
        });
    },
  },

  beforeDestroy() {
    document.body.style.overflow = '';
  },

  mounted() { /* кнопка партнёра
    if (!this.gameId) return;
    this.show_registration = this.gameId===this.event.uuid;
    if (this.gameId===this.event.uuid) {
      this.$nextTick(()=>this.$el.scrollIntoView());
      }  */
    if (this.expandedRegs.includes(this.event.uuid)) {
      this.$refs.registr.click();
      this.$emit('expandToggle', this.event.uuid);
    }
  },

  computed: {
    rotateArrow() {
      return !this.show_registration ? '' : 'rotate-arrow';
    },
    mobile() {
      return window.innerWidth < 840;
    },
    isCorpLeague() {
      return this.event.game_type.toLowerCase()
        .includes('корпоративная лига');
    },
  },
};
</script>

<style scoped lang="scss">

.grid {
  display: grid;
  grid-template-columns: 1.7fr 1.3fr 18rem;
}

.arrow {
  transition: 0.5s all;
}

.rotate-arrow {
  transform: rotate(180deg);
}

.copy-icon-class {
  width: 2.24rem;
  height: 2.2rem;
  border-radius: 100%;
  background-color: #e7e7e7;
}

button {
  @apply font-semibold;
}


$width: 15px;
$height: 15px;

$bounce_height: 30px;

body {
  position: relative;
  width: 100%;
  height: 100vh;
  font-family: Montserrat;
}

.wrap {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.text {
  color: #fbae17;
  display: inline-block;
  margin-left: 5px;
}

.bounceball {
  position: relative;
  display: inline-block;
  height: 37px;
  width: $width;

  &:before {
    position: absolute;
    content: '';
    display: block;
    top: 0;
    width: $width;
    height: $height;
    border-radius: 50%;
    background-color: #fbae17;
    transform-origin: 50%;
    animation: bounce 500ms alternate infinite ease;
  }
}

@keyframes bounce {
  0% {
    top: $bounce_height;
    height: 5px;
    border-radius: 60px 60px 20px 20px;
    transform: scaleX(2);
  }
  35% {
    height: $height;
    border-radius: 50%;
    transform: scaleX(1);
  }
  100% {
    top: 0;
  }
}

@media (max-width: 840px) {
  .arrow {
    transform: scale(0.4)
  }
  .divider {
    width: 85%;
    margin-left: auto;
    margin-right: auto;
    height: 1px;
    background-color: #979797
  }
}

@media (max-width: 767px) {
  .hide-element {
    display: none !important;
  }

  .grid {
    display: block;
  }
}
</style>
